import * as _ from "lodash";
import * as React from "react";
import { ConsultationPrescriptionItemRequest } from "@curefit/gmf-common";
import {AppConstants} from "../../../utils/AppConstants";
import IDoctorSpeciality from "../../../models/IDoctorSpeciality";

export interface ReferralPlanPDFProps {
    id: string;
    planItem: any;
    includeBorder: boolean;
    staticDoctorTypes: IDoctorSpeciality[];
    planType ?: any[];
}

const ReferralPlanPDFTemplate: React.StatelessComponent<ReferralPlanPDFProps> = (props: ReferralPlanPDFProps) => {
    let { id, planItem, staticDoctorTypes } = props;
    let itemToIterate = planItem[id];

    return (
        <div id={id} className="prescription-grid-row external-row">
        <div className="prescription-card-content">
            <h4 className="brandon-bold referral-header"><img src="/images/icons/referral-icon.svg" />REFERRALS</h4>
            <div id={`${id}-subsection`} className="prescription-description">
                {itemToIterate.map((referral: any, index: number) => {
                    const matchedDoctorDisplayTypeIndex = _.map(staticDoctorTypes, (value) => value).findIndex(item => item.doctorTypeCode === referral.doctorSpecialityCode);
                    const displayDoctorType = staticDoctorTypes[matchedDoctorDisplayTypeIndex].displayText;
                    const hasSchedule = !_.isEmpty(referral.when);
                    const hasReasons = !_.isEmpty(referral.comment);
                    return <div className={"referral-item"} key={index}>
                        <div>Speciality: <span className={"brandon-bold"}>{displayDoctorType}</span></div>
                        {
                            <div>
                                {
                                    hasSchedule && "In " + referral.when.count + " " + AppConstants.FrequencyUnit[referral.when.unit] + `${referral.when.count > 1 ? "s" : ""}`
                                }
                                {
                                    hasSchedule && hasReasons && ", "
                                }
                                {
                                    hasReasons && referral.comment
                                }
                            </div>
                        }
                    </div>
                })}
            </div>
        </div>
    </div>
    )
}

export default ReferralPlanPDFTemplate;